import { createFileRoute } from "@tanstack/react-router";
import { ForgotPassword } from "./glomt-losenord";

const TITLE = "Forgot password — Sellavo";
const DESCRIPTION = "Reset the password for your Sellavo account with a link sent by email.";

export const Route = createFileRoute("/en/forgot-password")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: ForgotPassword,
});
